/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MercerStandingValidationState {
  validationState?: MercerStandingValidationStateValidationStateEnum;
  lastAcknowledgedAt?: string | null;
  /**
   * True when the employee security settings mark the position evaluation as read only for the requester\'s role. Used by the job profile card to suppress its edit entry point.
   */
  isCpeReadonly?: boolean;
}
export enum MercerStandingValidationStateValidationStateEnum {
  Open = 'Open',
  RequestedHr = 'RequestedHR',
  RequestedCb = 'RequestedCB',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Review = 'Review'
}
